export const CONTROL_STAMP = "OWNER OVERRIDE CONSOLE";

export const CONTROL_SCAN_LINE = "Alert → Review → Override — you stay in command";

export const CONTROL_HEADLINE = {
  lead: "Absolute Control:",
  accent: "The AI Works For You",
};

export const CONTROL_SUBHEAD =
  "You never lose the pulse of your business. Step in exactly when your expertise is needed to close the contract.";

export const CONTROL_ALERT_MOCK = {
  title: "New activity",
  items: [
    { tag: "QUALIFIED", text: "Tile roof · 2-storey · leak near chimney" },
    { tag: "BOOKED", text: "Inspection Thu 9:00 AM — George St" },
  ],
  cta: "Open Dashboard",
};

export const CONTROL_ACTIONS = [
  {
    id: "alert",
    step: "01",
    verb: "ALERT",
    label: "Instant smart notifications",
    detail: "Pinged the moment a lead qualifies, an inspection books, or an emergency leak hits",
  },
  {
    id: "review",
    step: "02",
    verb: "REVIEW",
    label: "Seamless chat takeover",
    detail: "Open the dashboard, read the AI summary — storey count, material, damage — then jump in",
  },
  {
    id: "override",
    step: "03",
    verb: "OVERRIDE",
    label: "1-click manual pause",
    detail: "Complex strata quote? Pause the AI for that chat and take over instantly",
    highlight: true,
  },
];

export const CONTROL_PAYOFF =
  "The AI runs the front of the funnel. You pull the lever whenever the job needs a human closer.";
